import { render, staticRenderFns } from "./viewXminfo.vue?vue&type=template&id=962860ce&"
import script from "./viewXminfo.vue?vue&type=script&lang=js&"
export * from "./viewXminfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports